import React from 'react'
import { Col, Form } from 'react-bootstrap'

export interface BooleanMeetingResultProps {
  result: boolean
}

export const BooleanMeetingResult: React.FC<BooleanMeetingResultProps> = ({ result }) => {
  return (
    <Col className='p-2'>
      <Form.Check id='boolean-result' type='checkbox' disabled={true} className='d-flex'>
        <Form.Check.Input type='checkbox' disabled={true} checked={result} className='me-2 zocks-border-color-primary' />
      </Form.Check>
    </Col>
  )
}
